import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import CopyLinkButton from '../../CopyLinkButton/CopyLinkButton';
import './CommunitySharePopup.scss';
import SmallLinkedInButton from '../../SmallLinkedInButton/SmallLinkedInButton';
import SmallFacebookButton from '../../SmallFacebookButton/SmallFacebookButton';
import {
    CommunityContext,
    PageContext,
} from '../../../../../contexts/ContextCreator';
import { SHARE_DESTINATIONS } from './consts';

const CommunitySharePopup = ({
    hash,
    beforeOnClick,
    location,
    copyLinkMetric,
}) => {
    const {
        pageProps: { url },
    } = useContext(PageContext);
    const { getContent } = useContext(CommunityContext);
    const content = getContent(hash);
    const groupUrl = content?.group?.groupUrl || '';
    const domain = groupUrl.startsWith('http')
        ? groupUrl
        : `https://${url?.host}${groupUrl}`;
    let urlToShare = `${domain}${content.contentUrl}`;
    const isEditorialContentOrPodcast = content.type === 'editorial-content';
    if (isEditorialContentOrPodcast) {
        urlToShare = content.contentUrl;
    }

    // // TEMPORARY WHILE A/B TESTING
    const queryString = window?.location?.search;
    const urlParams = new URLSearchParams(queryString);
    const variant = urlParams.get('variant');
    const variantParam = variant ? `&variant=${variant}` : '';

    return (
        <div className="component-Community-ReactionBar-CommunityShareButton-CommunitySharePopup">
            <SmallLinkedInButton
                hash={hash}
                beforeOnClick={beforeOnClick}
                urlToShare={`${urlToShare}?utm_source=${SHARE_DESTINATIONS.LINKED_IN}&utm_medium=content-share${variantParam}`}
            />
            <SmallFacebookButton
                hash={hash}
                beforeOnClick={beforeOnClick}
                urlToShare={`${urlToShare}?utm_source=${SHARE_DESTINATIONS.FACEBOOK}&utm_medium=content-share${variantParam}`}
            />
            <CopyLinkButton
                hash={hash}
                onSuccess={copyLinkMetric}
                urlToShare={`${urlToShare}?utm_source=${SHARE_DESTINATIONS.CLICKED_LINK}&utm_medium=content-share${variantParam}`}
                location={location}
            />
        </div>
    );
};

CommunitySharePopup.propTypes = {
    hash: PropTypes.string.isRequired,
    beforeOnClick: PropTypes.func,
    location: PropTypes.string,
    copyLinkMetric: PropTypes.func,
};

CommunitySharePopup.defaultProps = {
    beforeOnClick: () => {},
    location: 'masterFeed',
    copyLinkMetric: () => {},
};

CommunitySharePopup.displayName = 'CommunitySharePopup';

export default React.memo(CommunitySharePopup);
